import { AxiosResponse } from 'axios'
import { UseMutateFunction } from '@tanstack/react-query'
import { FormInstance } from 'antd'
import { Socket } from 'socket.io-client'

export interface FormTransferProps {
  form: FormInstance<any>
  beneficiaryCurrency: number | undefined
  setBeneficiaryCurrency: React.Dispatch<
    React.SetStateAction<number | undefined>
  >
  paymentCurrency: number | undefined
  setPaymentCurrency: React.Dispatch<React.SetStateAction<number | undefined>>
  companyDefaultSelected: any
  setCompanyDefaultSelected: React.Dispatch<any>
  companyDefaultCurrency: any
  dataCompaniesDefault: any
  loadingDefaulCompany: boolean
  loadingCompanyCurrency: boolean
  setSearchDefaultCompany: React.Dispatch<any>
  paramsWalletProvider: {
    start: number
    end: number
  }
  setParamsWalletProvider: React.Dispatch<
    React.SetStateAction<{
      start: number
      end: number
    }>
  >
  walletSelectedProvider: any
  setWalletSelectedProvider: React.Dispatch<any>
  dataListWalletProvider: any
  paramsBankAccountProvider: {
    start: number
    end: number
  }
  setParamsBankAccountProvider: React.Dispatch<
    React.SetStateAction<{
      start: number
      end: number
    }>
  >
  bankAccountSelectedProvider: any
  setBankAccountSelectedProvider: React.Dispatch<any>
  dataListBankAccountProvider: any
  dataListSender: {
    total: number
    page: number
    pageSize: number
    totalPages: number
    items: []
  }
  senderSelected: any
  setSenderSelected: React.Dispatch<any>
  paramsSender: {
    start: number
    end: number
  }
  setParamsSender: React.Dispatch<
    React.SetStateAction<{
      start: number
      end: number
    }>
  >
  getDetailRequestMoney: UseMutateFunction<
    AxiosResponse<any, any>,
    unknown,
    number,
    unknown
  >
  loadingDetail: boolean
  setAddSender: React.Dispatch<React.SetStateAction<boolean>>
  dataAllCurrency: any[]
}

export const listPayFee = [
  {
    value: 'sender',
    label: 'Sender pays fee',
  },
  {
    value: 'beneficiary',
    label: 'Beneficiary pays fee',
  },
]

export const listMethod = {
  CRYPTO_FIAT: 'CRYPTO_FIAT',
  CRYPTO_CRYPTO: 'CRYPTO_CRYPTO',
  FIAT_CRYPTO: 'FIAT_CRYPTO',
  FIAT_FIAT: 'FIAT_FIAT',
}

export const listTransferMode = {
  CRYPTO_NETWORK: 'CRYPTO_NETWORK',
  BANK_TRANSFER: 'BANK_TRANSFER',
  INTERNAL_TRANSFER: 'INTERNAL_TRANSFER',
}

export const listPaymentMethod = {
  PORTFOLIO: 'PORTFOLIO',
  DIRECTER_TRANSFER: 'DIRECTER_TRANSFER',
}

export const Fiat = [
  'USD',
  'EUR',
  'HKD',
  'AUD',
  'JPY',
  'CHF',
  'CNY',
  'AED',
  'SGD',
  'GBP',
]
export const Crypto = ['USDT', 'DAI', 'ETH']
